import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
// ----------------------------------------------------------------------

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow,serialNumber }) {
    const {first_name, last_name,title,email, company_name,vendor_type } = row;

    const confirm = useBoolean();
    const quickEdit = useBoolean();
    const popover = usePopover();
    return (
        <>
            <TableRow hover selected={selected}>
                <TableCell padding="checkbox">
                    <Checkbox checked={selected} onClick={onSelectRow} />
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{serialNumber}</TableCell>
                <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                    <ListItemText
                        primary={first_name}
                        primaryTypographyProps={{ typography: 'body2' }}
                        secondaryTypographyProps={{
                            component: 'span',
                            color: 'text.disabled',
                        }}
                    />
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{last_name}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{email}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{title}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{company_name}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{vendor_type}</TableCell>
                {/* <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
                </TableCell> */}
            </TableRow>            
           
            <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                arrow="right-top"
                sx={{ width: 140 }}
            >
                <MenuItem
                    onClick={() => {
                        confirm.onTrue();
                        popover.onClose();
                    }}
                    sx={{ color: 'error.main' }}
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onEditRow();
                        popover.onClose();
                    }}
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>
               



            <ConfirmDialog
                open={confirm.value}
                onClose={confirm.onFalse}
                title="Delete"
                content="Are you sure want to delete?"
                action={
                    <Button variant="contained" color="error" onClick={onDeleteRow}>
                        Delete
                    </Button>
                }
            />
        </>
    );
}
UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};